import { render, staticRenderFns } from "./ConfigAutorizaciones.vue?vue&type=template&id=14f8919e&"
import script from "./ConfigAutorizaciones.vue?vue&type=script&lang=ts&"
export * from "./ConfigAutorizaciones.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigAutorizaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('14f8919e', component.options)
    } else {
      api.reload('14f8919e', component.options)
    }
    module.hot.accept("./ConfigAutorizaciones.vue?vue&type=template&id=14f8919e&", function () {
      api.rerender('14f8919e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ConfigAutorizaciones/ConfigAutorizaciones.vue"
export default component.exports